export const CHANGE_PASSWORD = "changePassword";
export const UPDATE_USER_PROFILE = "updateUserProfile";
export const SAVE_UPDATED_PROFILE_IMAGE = "updateProfileImage";
export const UNLINK_FACEBOOK = "unlinkFacebook";